import { PolicyNavbar } from '../components/website/PolicyNavbar';
import Footer from '../components/website/Footer';
import './PrivacyandTermsOfUse.css';

export const TermsOfUse = () => {
  return (
    <div>
      <PolicyNavbar />
      <div className="policy-container">
        <div className="policy-header">
          <h1>Terms of Use.</h1>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">1</div>
            <h2>Introduction</h2>
          </div>
          <p>
            These terms and conditions of use and service (“Terms”) contained herein on this webpage is a legal
            agreement between you (“you”, “User”) and Statust'rust, LLC (“Statustrust,” “we,” “our,” or “us”). These
            Terms shall govern your access to and use of our services which include the use of our platform, web,{' '}
            <a href="https://statustrust.io/" target="_blank" rel="noreferrer" className="colored-link">
              https://statustrust.io/
            </a>{' '}
            (“Platforms”). Note that these Terms apply to you whether you are only visiting the website or have
            registered to be a user of the Services.
          </p>
          <p>
            These Terms apply in full force and effect to your use of the Services and by using any of the Services, you
            expressly accept all terms and conditions contained herein in full and without limitation or qualification,
            including our Data Protection and Privacy Policy. We oblige you therefore thoroughly read these Terms
            carefully before agreeing to be bound by them. You must not use any of the Services if you have any
            objection to any of these Terms.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">2</div>
            <h2>Eligibility</h2>
          </div>
          <p>
            By signing on to use our Services, you are warranting that you are not a person barred from receiving
            services under the laws of the applicable jurisdiction. You also undertake and agree to provide us with
            information that is accurate, and not to misrepresent your identity or your user information. You are only
            entitled to access and use the Services for lawful purposes.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">3</div>
            <h2>Age Restriction</h2>
          </div>
          <p>
            Our Services are directed to people from the ages of 18 and above. You are only permitted to use the
            Services if you are (a) aged 18 or older; and (b) you have not previously been suspended or removed from the
            Services. We do not knowingly engage people younger than the age of 18. If as a parent or guardian, you
            become aware that your child or ward has provided us with any information without your consent, please
            contact us through the details provided in these Terms. If you are an entity, organisation, or company, the
            individual accepting these Terms on your behalf represents and warrants that they have the authority to bind
            you to these Terms and you agree to be bound by these Terms.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">4</div>
            <h2>Provision of Services</h2>
          </div>
          <div className="subsection">
            <h3>A. The Service</h3>
            <p>
              Statustrust is an incident communication platform designed to enhance transparency and reliability for
              businesses. It enables organisations to provide real-time status updates to customers, employees, and
              stakeholders, reducing support overhead and improving operational efficiency.
            </p>
            <p>We provide value to our Users via the following features:</p>
            <ul>
              <li>
                Public & Private Service Status Monitoring: Our Platform allows you to create external-facing pages for
                customers and internal pages for employees with access control settings.
              </li>
              <li>
                Ping Service: With our Platform, Users are able to monitor public services and receive uptime/downtime
                notifications.
              </li>
              <li>
                Subscriber Notifications: Users can subscribe to updates via email, messaging apps (such as Slack and
                Teams), or webhook notifications.
              </li>
              <li>
                Customisable Templates: Configure messaging, branding, and incident categories to match your
                requirements.
              </li>
              <li>
                Performance Analytics & Reporting: You are able to track historical incidents, analyse downtime trends,
                and optimise incident response strategies.
              </li>
              <li>
                Multi-Tier Communication: Implement role-based access control for streamlined communication with our
                Platform.
              </li>
            </ul>

            <h3>B. Access to the Services</h3>
            <p>
              In order to access and use the Services, you will need to use our Statustrust web where you will register
              and input the required details and create an account with us. To use our services, you must where
              required, grant Statustrust voluntary access to these features.
              <br /> As part of registration, you may be required to undertake a verification process to verify your
              email address and set up the account.
              <br /> We shall have the right to display the information, feedback, ratings, reviews etc. provided by you
              on the Platform. You agree and accept that as of the date of your registration on the Platform, the
              information provided by you is complete, accurate and up-to-date. In the event of any change to such
              information, it is your responsibility to update it promptly and, where required, notify us in writing at
              least 7 (seven) days before the change takes effect.. You acknowledge and accept that we have not
              independently verified the information provided by you. We shall in no way be responsible or liable for
              the accuracy or completeness of any information provided by you. If you provide any information that is
              untrue, inaccurate, not current or incomplete, or we have reasonable grounds to suspect that such
              information is untrue, inaccurate, not current or incomplete, we reserve the right to suspend or terminate
              your Account and refuse any and all current or future use of the Platform (or any portion thereof) at any
              time.
            </p>
            <p>
              We may launch, change, upgrade, impose conditions to, suspend, or stop any Services (or any features
              within the Services) to you or subject to other conditions that we may impose in our discretion, without
              prior notice except that in case of a fee-based Service, such changes will not substantially adversely
              affect the paying Users in enjoying that Service.
            </p>
          </div>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">5</div>
            <h2>License to use our platform</h2>
          </div>
          <p>
            We grant you a non-assignable, non-exclusive and revocable license to use our Web and any of our platforms
            in the manner permitted by these Terms. This license grant includes all updates, upgrades, new versions and
            replacement platforms for you to use in connection with our Services. The Services are protected by
            copyright, trademark, and other laws of both the United States and foreign countries. For emphasis, nothing
            in these Terms gives you a right to use our name or any of our trademarks, logos, domain names, and other
            distinctive brand features. All rights, title and interest in and to the Services are and will remain our
            and/or licensors’ exclusive property. You also agree not to alter, re-design, reproduce, adapt, display,
            distribute, translate, disassemble, reverse engineer, or otherwise attempt to create any source code that is
            derived from our Platform.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">6</div>
            <h2>Paid Subscription</h2>
          </div>
          <p>
            Although our Web is free, when you choose to take advantage of our paid subscription services, payment of
            the amount shown to you at the time of subscription will be charged to your account when the subscription
            begins. Payments are nonrefundable and there are no refunds or credits for partially used subscription
            periods. Statustrust offers these <span className="colored-link">subscription plans.</span>
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">7</div>
            <h2>Third party services and linked websites</h2>
          </div>
          <p>
            Our Platform may also contain links to third-party websites or resources. You acknowledge and agree that
            Statustrust is not responsible or liable for: (i) the availability or accuracy of such websites or
            resources; or (ii) the content, products, or services on or available from such websites or resources. Links
            to such websites or resources do not imply any endorsement by Statustrust of such websites or resources or
            the content, products, or services available from such websites or resources. You acknowledge sole
            responsibility for and assume all risk arising from your use of any such websites or resources or the
            content, products or services on or available from such websites or resources. Please be sure to review the
            terms of use and privacy policy of any third-party services before you share any user content or information
            with such third-party services. Once sharing occurs, Statustrust will have no control over the information
            that has been shared.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">8</div>
            <h2>Personal security</h2>
          </div>
          <p>
            You also agree to maintain the security of your details and account and promptly notify us if you discover
            or suspect that someone has accessed your account without your authorisation. Your username and password are
            personal to you and may not be shared with any third parties. You are responsible for all activities that
            occur regarding your details or otherwise under your account.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">9</div>
            <h2>Feedback</h2>
          </div>
          <p>
            We respect and appreciate the thoughts and comments from our Users If you choose to provide input and
            suggestions regarding existing functionalities, problems with or proposed modifications or improvements to
            the Service (“Feedback”), then you hereby grant Statustrust an unrestricted, perpetual, irrevocable,
            non-exclusive, fully-paid, royalty-free right and license to exploit the Feedback in any manner and for any
            purpose, including to improve the Service and create other products and services. We will have no obligation
            to provide you with attribution for any Feedback you provide to us.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">10</div>
            <h2>Intellectual Property</h2>
          </div>
          <p>
            Unless otherwise stated, we own the intellectual property rights and materials on our Site and all our
            Platforms. All text, formatting (including without limitation the arrangement of materials on our website
            and platforms and the graphics, animation, tools, commercials, music, video, articles, sound, copy, trade
            names, logos and other materials and information on the website and platforms are subject to our
            intellectual property rights. We do not grant you any right, license, title or interest to any of our
            intellectual property rights that you may or may not have access to.  
          </p>
          <p>
            This content may not be copied, reverse-engineered, decompiled, disassembled, modified or reposted to other
            websites. Nothing on our platforms should be construed as granting by implication or otherwise, any license
            or right to use any trademark displayed on our website or platforms without our written permission or that
            of such third party that may own the trademark. You agree to take such actions including executing all
            documents that may be needed to further affirm our intellectual property rights.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">11</div>
            <h2>Warranty Disclaimer</h2>
          </div>
          <p>
            WE TRY TO KEEP OUR WEBSITE AND SERVICES AVAILABLE AT ALL TIMES, BUG-FREE AND SAFE, HOWEVER, YOU USE IT AT
            YOUR OWN RISK. WE PROVIDE THE WEBSITE AND THE CONTENT “AS IS” WITH NO WARRANTY, EXPRESS OR IMPLIED, OF ANY
            KIND (INCLUDING ANY IMPLIED WARRANTY OR CONDITION OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
            AVAILABILITY, SECURITY, TITLE, AND NON-INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS). WITHOUT LIMITING THE
            GENERALITY OF THE FOREGOING, WE MAKE NO WARRANTY THAT OUR WEBSITE, PLATFORM, PRODUCTS AND SERVICES WILL MEET
            YOUR REQUIREMENTS OR THAT OUR WEBSITE WILL BE 100% FRAUD OR FAIL PROOF, REMAIN FREE FROM ANY INTERRUPTION,
            BUGS, INACCURACIES, AND ERROR FREE. YOUR USE OF OUR SERVICES ARE AT YOUR OWN RISK AND YOU ALONE WILL BE
            RESPONSIBLE FOR ANY DAMAGE THAT RESULTS IN THE LOSS OF DATA OR DAMAGE TO YOUR COMPUTER SYSTEM. NO ADVICE OR
            INFORMATION, WHETHER ORAL OR WRITTEN OBTAINED BY YOU FROM OUR WEBSITE, PLATFORM OR OUR SERVICES WILL CREATE
            ANY WARRANTY OR CONDITION NOT EXPRESSLY STATED. WE WARRANT THAT WE SHALL USE OUR BEST ENDEAVOURS TO ENSURE
            THAT THE SERVICE OPERATES OPTIMALLY AT ALL TIMES IN ACCORDANCE WITH BEST INDUSTRY STANDARDS.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">12</div>
            <h2>Limitation of Liability</h2>
          </div>
          <p>
            UNDER NO CIRCUMSTANCE SHALL WE BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL PUNITIVE, CONSEQUENTIAL,
            SPECIAL OR EXEMPLARY DAMAGES, INCLUDING DAMAGES RESULTING FROM REVENUE LOSS, PROFIT LOSS, USE, DATA,
            GOODWILL, BUSINESS INTERRUPTION OR ANY OTHER INTANGIBLE LOSSES (WHETHER OR NOT WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH) ARISING OUT OF OUR WEBSITE OR SERVICES (INCLUDING, WITHOUT LIMITATION TO INABILITY TO
            USE, OR ARISING FROM THE RESULT OF USE OF OUR WEBSITE, PLATFORM OR SERVICES) WHETHER SUCH DAMAGES ARE BASED
            ON WARRANTY, TORT, CONTRACT, STATUTE OR ANY OTHER LEGAL THEORY.  SOME JURISDICTIONS DO NOT ALLOW THE
            EXCLUSION OF CERTAIN WARRANTIES OR LIMITATIONS ON THE SCOPE AND DURATION OF SUCH WARRANTIES, SO THE ABOVE
            DISCLAIMERS MAY NOT APPLY TO YOU IN THEIR ENTIRETY BUT SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY
            APPLICABLE LAW.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">13</div>
            <h2>Indemnification</h2>
          </div>
          <p>
            You hereby indemnify us and undertake to keep us, our staff and affiliates indemnified against any losses,
            damages, costs, liabilities and expenses (including without limitation reasonable legal fees and expenses)
            arising out of or in any way related to:
          </p>
          <ol className="indemnification">
            <li>your access to, use of, or inability to use your account or the Services;</li>
            <li>your breach or alleged breach of this Agreement;</li>
            <li>
              your violation of any rights of a third party, including but not limited to any negligent or willful
              misconduct of your employees, contractors, or agents, or a breach of any contracts or other relationships
              between you and third parties;
            </li>
            <li>your violation of any applicable law; or </li>
            <li>
              your failure to provide and maintain true, accurate, current and complete information in your account. 
            </li>
          </ol>
          <p>
            You shall cooperate as fully as reasonably required in the defense of any such claim. Statustrust reserves
            the right, at its own expense, to assume the exclusive defence and control of any matter subject to
            indemnification by you. You agree not to settle any matter without the prior written consent of Statustrust.
            For the avoidance of doubt, this indemnification, defence and hold harmless obligation will survive these
            Terms of Service and the termination of your use of the Services.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">14</div>
            <h2>Force Majeure</h2>
          </div>
          <p>
            Under no circumstances shall we be held liable for any delay or failure or disruption of the content or
            services delivered through our Web and platforms resulting directly or indirectly from acts of nature,
            forces or causes beyond our reasonable control, including without limitation, Internet failures, computer,
            telecommunications or any other equipment failures, electrical power failures, strikes, labour disputes,
            riots, insurrections, civil disturbances, shortages of labour or materials, fires, flood, storms,
            explosions, acts of God, war, governmental actions, orders of domestic or foreign courts or tribunals or
            non-performance of third parties.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">15</div>
            <h2>Breaches of these terms</h2>
          </div>
          <p>
            Without prejudice to other rights accruable to us under these Terms, any breach of these Terms will warrant
            our institution of such measures that we deem appropriate to deal with the breach, which may include but
            shall not be limited to suspending or prohibiting your access to and/or use of our website and other
            platforms, blocking computers using your IP address from accessing our website or other platforms,
            contacting your internet service provider to request that they block your access to our website or other
            platforms and/or bringing court proceedings against you.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">16</div>
            <h2>Privacy Policy</h2>
          </div>
          <p>
            Please read our Data Protection and Privacy Policy (“Privacy Policy”) carefully for information relating to
            our collection, use, storage, and disclosure of your personal information. The Privacy Policy is
            incorporated by this reference into, and made a part of, these Terms.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">17</div>
            <h2>Updates, modifications and amendments</h2>
          </div>
          <p>
            We reserve the right to update, modify, change or revise these Terms from time to time. The changes will not
            be retroactive, and the most current version of the Terms will always be on this page and will continue to
            govern our relationship with you. We advise that you check this page often, referring to the date of the
            last modification on the page. We will also try to notify you of any material changes which could be done
            via email associated with your account or service notification. By continuing to use our Services after the
            changes become effective, you agree to be bound by the revised Terms.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">18</div>
            <h2>Updates, modifications and amendments</h2>
          </div>
          <p>
            All legal notices or demands to or upon us shall be made in writing and sent to us personally, by courier,
            certified mail, to our registered address on our website and our contact e-mail in the “Contact Us” clause
            below.  All legal notices or demands to or upon a User shall be effective if either delivered personally,
            sent by courier, certified mail, or email to the last-known correspondence, fax or email address provided by
            the User. You agree that all agreements, notices, demands, disclosures and other communications that we send
            to you electronically satisfy the legal requirement that such communication should be in writing.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">19</div>
            <h2>Updates, modifications and amendments</h2>
          </div>
          <p>
            These Terms of Use shall be interpreted and governed by the laws currently in force in the State of
            Delaware. We shall try to settle all disputes amicably. Any dispute arising out of these Terms which cannot
            be settled, by mutual agreement/negotiation within 1 (one) month shall be referred to the exclusive
            jurisdiction of a Court of competent jurisdiction in the State of Delaware, United States.
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">20</div>
            <h2>Updates, modifications and amendments</h2>
          </div>
          <p>
            If you have any complaints, feedback and/or questions about us, our Services and/or these Terms, you may
            contact us at{' '}
            <a href="mailto: support@statustrust.io" className="colored-link">
              support@statustrust.io 
            </a>
          </p>
        </div>

        <div className="policy-section">
          <div className="section-header">
            <div className="section-number">21</div>
            <h2>Effective date</h2>
          </div>
          <p>This Terms of Use and Service is effective this 03 day of April 2025.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;
